// extracted by mini-css-extract-plugin
export default {"icon":"UserCardActionsPanel_icon--Ain","iconContainer":"UserCardActionsPanel_iconContainer--CLC"};